export default "__VITE_PUBLIC_ASSET__edf65712__"